import _ from "lodash";

export class ProcessorItemRows {
    public static MakeRowsFromItem(item: any, type: "mis" | "sds", includeNullFields: boolean): ProcessorItemRow[] {
        return this.MapFields(item, type, includeNullFields);
    }

    private static MapFields(item: any, type: "mis" | "sds", includeNullFields: boolean): ProcessorItemRow[] {
        return _.keys(item).filter((key) => {
            return key !== "$type" && (includeNullFields || item[key] !== null);
        }).map(key => {
            if (item[key] === null) {
                return { key, type, value: null }
            }
            else if (typeof item[key] !== "object") {
                return { key, type, value: item[key].toString() };
            }
            else if (Array.isArray(item[key]))
            {
                return { key, type, value: item[key].map((value: any, index: number) => {
                    return { key: index, type, value: this.MapFields(value, type, includeNullFields) };
                })};
            }
            else {
                return { key, type, value: this.MapFields(item[key], type, includeNullFields) };
            }
        });
    }

}

export interface ProcessorItemRow {
    key: string;
    type: string;
    value: string | ProcessorItemRow[];
}